<template>
  <div>
    <h3 class="font-weight-bold mb-4">การจัดการขนส่ง</h3>
    <div>
      <b-container class="p-0">
        <b-row class="no-gutters">
          <b-col>
            <div class="mr-2">
              <div class="header-purple">ขนส่งที่ให้บริการในระบบ</div>
              <div class="p-3 shipment-container">
                <div v-if="isLoading">Loading</div>
                <div v-else>
                  <b-form-radio-group
                    v-model="selectShippingTypeId"
                    :options="shippingTypes"
                    class="custom-radio mb-3"
                    value-field="id"
                    text-field="name"
                    stacked
                    @change="onShippingTypeChange"
                  ></b-form-radio-group>
                </div>
              </div>
            </div>
          </b-col>
          <b-col>
            <div class="ml-2">
              <div class="header-purple">ขนส่งที่ให้บริการในระบบ</div>
              <div class="p-3 shipment-container">
                <InputText
                  textFloat="น้ำหนัก (ค่าเริ่มต้น)"
                  placeholder="กรุณาระบุน้ำหนักเริ่มต้นของสินค้า (หน่วยเป็นกรัม)"
                  type="text"
                  name="weight"
                  v-model="form.defaultWeight"
                  isRequired
                  :isValidate="$v.form.defaultWeight.$error"
                  :v="$v.form.defaultWeight"
                  @onKeypress="isNumber($event)"
                />
                <InputText
                  textFloat="ความกว้าง (ค่าเริ่มต้น)"
                  placeholder="กรุณาระบุความกว้างเริ่มต้นของสินค้า (หน่วยเป็นเซนติเมตร)"
                  type="text"
                  name="length"
                  v-model="form.defaultWidth"
                  isRequired
                  :isValidate="$v.form.defaultWidth.$error"
                  :v="$v.form.defaultWidth"
                  @onKeypress="isNumber($event)"
                />
                <InputText
                  textFloat="ความยาว (ค่าเริ่มต้น)"
                  placeholder="กรุณาระบุความยาวเริ่มต้นของสินค้า (หน่วยเป็นเซนติเมตร)"
                  type="text"
                  name="width"
                  v-model="form.defaultLength"
                  isRequired
                  :isValidate="$v.form.defaultLength.$error"
                  :v="$v.form.defaultLength"
                  @onKeypress="isNumber($event)"
                />
                <InputText
                  textFloat="ความสูง (ค่าเริ่มต้น)"
                  placeholder="กรุณาระบุความสูงเริ่มต้นของสินค้า (หน่วยเป็นเซนติเมตร)"
                  type="text"
                  name="height"
                  v-model="form.defaultHeight"
                  isRequired
                  :isValidate="$v.form.defaultHeight.$error"
                  :v="$v.form.defaultHeight"
                  @onKeypress="isNumber($event)"
                />
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
      <div class="mt-3 d-flex justify-content-end">
        <b-button class="btn-main" :disabled="isDisabled" @click="checkForm"
          >บันทึก
        </b-button>
      </div>
    </div>
    <ModalAlert
      ref="modalAlert"
      :text="modalMessage"
      v-on:hadleModalAlertClose="hadleModalAlertClose"
    />
    <ModalAlertError ref="modalAlertError" :text="modalMessage" />
    <ModalLoading ref="modalLoading" :hasClose="false" />
  </div>
</template>

<script>
import { required, requiredIf, minValue } from "vuelidate/lib/validators";
import InputText from "@/components/inputs/InputText";
import ModalAlert from "@/components/modal/alert/ModalAlert";
import ModalAlertError from "@/components/modal/alert/ModalAlertError";
import ModalLoading from "@/components/modal/alert/ModalLoading";
export default {
  components: {
    InputText,
    ModalAlert,
    ModalAlertError,
    ModalLoading,
  },
  data() {
    return {
      shippingTypes: [],
      brandShippings: [],
      selectShippingTypeId: 1,
      isLoading: false,
      isDisabled: false,
      modalMessage: "",
      form: {
        brandId: 0,
        shippingTypeId: 0,
        defaultHeight: 0,
        defaultLength: 0,
        defaultWidth: 0,
        defaultWeight: 0,
      },
    };
  },
  created: async function () {
    await this.getShippingData();
  },
  validations: {
    form: {
      defaultHeight: { required },
      defaultLength: { required },
      defaultWidth: { required },
      defaultWeight: { required },
    },
  },
  methods: {
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;

      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    hadleModalAlertClose: async function () {
      await this.getShippingData();
    },
    getShippingData: async function () {
      this.isLoading = true;
      await this.axios
        .get(`${this.$baseUrl}/shipping/brandshipping`)
        .then((data) => {
          this.shippingTypes = data.detail.shippingTypes;
          this.selectShippingTypeId = data.detail.selectShippingTypeId;
          this.brandShippings = data.detail.brandShippings;
          this.getShippingForm();
          this.isLoading = false;
        });
    },
    getShippingForm: async function () {
      let form = this.brandShippings.find(
        (el) => el.shippingTypeId == this.selectShippingTypeId
      );
      if (form) {
        this.form = form;
      }
    },
    onShippingTypeChange(value) {
      this.selectShippingTypeId = value;
      this.getShippingForm();
    },
    checkForm: async function () {
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        return;
      }

      this.isDisabled = true;
      this.$refs.modalLoading.show();
      await this.onSaveShippingForm();
    },
    onSaveShippingForm: async function () {
      await this.axios
        .post(`${this.$baseUrl}/shipping/brandshipping`, this.form)
        .then((data) => {
          this.isDisabled = false;
          if (data.result == 1) {
            this.modalMessage = "สำเร็จ";
            this.$refs.modalLoading.hide();
            this.$refs.modalAlert.show();
          } else {
            this.modalMessage = data.message;
            this.$refs.modalLoading.hide();
            this.$refs.modalAlertError.show();
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.shipment-container {
  min-height: 400px;
  background-color: #ffffff;
}
</style>